// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"index_tooltip_3A3EM"};